import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { Button, Input, Select } from '@ipc/ipc-components';
import DateFnsUtils from '@date-io/date-fns';
import Grid from '@material-ui/core/Grid';
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import locale from 'date-fns/locale/en-US';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as moment from 'moment';
import { getAssetType } from '../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import DATE_FORMATS from '../../../../common/models/constants/dateFormats';
import {
  getImpcsOfSingleInboundOperatorRequestActionCreator,
  getImpcsOfSingleOutboundOperatorRequestActionCreator,
} from '../../../../common/selection-criteria/impcs-per-operator/redux/actions/ImpcsOfSingleOperatorActions';
import { getInboundImpcsOfSingleOperator, getLeftPostalOperatorsCodesOnly, getOutboundImpcsOfSingleOperator } from '../../../../common/user/redux/selectors/UserDataSelectors';
import {
  postRepatriationsTransactionsCreateRequestActionCreator,
} from '../../../impc-stock-levels/transactions/internal-repatriations/create/redux/actions/InternalRepatriationsTransactionsCreateActions';

if (locale && locale.options) {
  locale.options.weekStartsOn = 1;
}

const operators = process.env.relatedOperators;
const relatedOperators = operators.split('|');

class InternalRepatriationCreateFormDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comments: props.row.row.comments,
      departureDateTime: moment(props.row.row.departureDate).format('YYYY-MM-DD HH:mm:ss'),
      impcFrom: props.data.outboundImpc,
      impcTo: props.data.inboundImpc,
      operatorFrom: props.data.outboundOperator,
      operatorTo: props.data.inboundOperator,
      plannedArrivalDateTime: moment(props.row.row.arrivalDate).format('YYYY-MM-DD HH:mm:ss'),
      quantity: props.row.row.quantity,
      errorQuantity: '',
    };
    this.handleNewOutboundOperator = this.handleNewOutboundOperator.bind(this);
    this.handleNewOutboundIMPC = this.handleNewOutboundIMPC.bind(this);
    this.handleNewInboundOperator = this.handleNewInboundOperator.bind(this);
    this.handleNewInboundIMPC = this.handleNewInboundIMPC.bind(this);
    this.handleQuantity = this.handleQuantity.bind(this);
    this.handleComments = this.handleComments.bind(this);
    this.handleDepartureDate = this.handleDepartureDate.bind(this);
    this.handleArrivalDate = this.handleArrivalDate.bind(this);
    this.confirmCreate = this.confirmCreate.bind(this);
    this.props.getImpcsOfSingleOutboundOperatorRequestActionCreator(this.props.appContext.appContext, props.data.outboundOperator);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.operatorTo !== prevState.operatorTo) {
      this.props.getImpcsOfSingleInboundOperatorRequestActionCreator(this.props.appContext.appContext, this.state.operatorTo);
    }
    if (this.state.operatorFrom !== prevState.operatorFrom) {
      this.props.getImpcsOfSingleOutboundOperatorRequestActionCreator(this.props.appContext.appContext, this.state.operatorFrom);
    }
  }

  isFormValid = () => !(this.state.quantity === ''
    || this.state.quantity === undefined
    || (moment(this.state.departureDateTime).isAfter(this.state.plannedArrivalDateTime))
    || this.state.departureDateTime === 'Invalid date'
    || this.state.plannedArrivalDateTime === 'Invalid date'
    || this.state.impcFrom === 'Select IMPC'
    || this.state.impcTo === 'Select IMPC'
    || this.state.errorQuantity === 'Quantity value can not be negative'
    || this.state.impcTo === undefined)

  handleNewOutboundOperator(selectedOption) {
    this.props.getImpcsOfSingleOutboundOperatorRequestActionCreator(this.props.appContext.appContext, selectedOption.value);
    if (relatedOperators.includes(selectedOption.value) && relatedOperators.includes(this.state.operatorTo)) {
      this.setState({
        operatorFrom: selectedOption.value,
        impcFrom: 'Select IMPC',
      });
    } else {
      this.setState({
        operatorFrom: selectedOption.value,
        operatorTo: selectedOption.value,
        impcFrom: 'Select IMPC',
        impcTo: 'Select IMPC',
      });
    }
  }

  handleNewOutboundIMPC(selectedOption) {
    this.setState({
      impcFrom: selectedOption.value,
    });
  }

  handleNewInboundOperator(selectedOption) {
    this.props.getImpcsOfSingleInboundOperatorRequestActionCreator(this.props.appContext.appContext, selectedOption.value);
    if (relatedOperators.includes(selectedOption.value) && relatedOperators.includes(this.state.operatorFrom)) {
      this.setState({
        operatorTo: selectedOption.value,
        impcTo: 'Select IMPC',
      });
    } else {
      this.setState({
        operatorTo: selectedOption.value,
        operatorFrom: selectedOption.value,
        impcFrom: 'Select IMPC',
        impcTo: 'Select IMPC',
      });
    }
  }

  handleNewInboundIMPC(selectedOption) {
    this.setState({
      impcTo: selectedOption.value,
    });
  }

  handleQuantity(e) {
    let error = '';
    if (parseInt(e.target.value, 0) < 0) {
      error = 'Quantity value can not be negative';
    }
    this.setState({
      quantity: e.target.value,
      errorQuantity: error,
    });
  }

  handleComments(e) {
    this.setState({
      comments: e.target.value,
    });
  }

  handleDepartureDate(date) {
    this.setState({
      departureDateTime: moment(date).format(DATE_FORMATS.inputDateTime),
    });
    if (moment(date).isAfter(moment(this.state.plannedArrivalDateTime))) {
      this.setState({
      });
    }
  }

  handleArrivalDate(date) {
    this.setState({
      plannedArrivalDateTime: moment(date).format(DATE_FORMATS.inputDateTime),
    });
  }

  mapImpcListToSelectOptions(listToMappedOptions) {
    const mappedList = [];
    listToMappedOptions.map((item) => {
      const impc = {
        label: item,
        value: item,
      };
      return mappedList.push(impc);
    });
    return mappedList;
  }

  confirmCreate() {
    this.props.postRepatriationsTransactionsCreateRequestActionCreator(
      this.props.appContext,
      this.state.departureDateTime,
      this.state.comments,
      this.state.impcTo,
      this.state.operatorTo,
      this.state.impcFrom,
      this.state.operatorFrom,
      this.state.plannedArrivalDateTime,
      this.state.quantity,
    );
    this.props.closeDialog();
  }

  render() {
    return (
      <Dialog onClose={this.props.closeDialog} aria-labelledby="simple-dialog-title" open={this.props.openDialog}>
        <DialogTitle id="simple-dialog-title">Create Internal Repatriation</DialogTitle>
        <div style={{ float: 'left' }}>
          <table className="operator-impc-detail">
            <tbody>
              <tr>
                <td className="selected-impc">
                  Outbound Operator
                </td>
                <td className="selected-impc">
                  <Select
                    value={this.state.operatorFrom}
                    placeholder={this.state.operatorFrom}
                    options={this.props.operatorFromOptions}
                    onChange={this.handleNewOutboundOperator}
                  />
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Outbound IMPC
                </td>
                <td className="selected-impc">
                  <Select
                    value={this.state.impcFrom}
                    placeholder={this.state.impcFrom}
                    options={this.mapImpcListToSelectOptions(this.props.impcFromList.filter((item) => item !== this.state.impcTo))}
                    onChange={this.handleNewOutboundIMPC}
                  />
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Inbound Operator
                </td>
                <td className="selected-impc">
                  <Select
                    value={this.state.operatorTo}
                    placeholder={this.state.operatorTo}
                    options={this.props.operatorToOptions}
                    onChange={this.handleNewInboundOperator}
                  />
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Inbound IMPC
                </td>
                <td className="selected-impc">
                  <Select
                    value={this.state.impcTo}
                    placeholder={this.state.impcTo}
                    options={this.mapImpcListToSelectOptions(this.props.impcToList.filter((item) => item !== this.state.impcFrom))}
                    onChange={this.handleNewInboundIMPC}
                  />
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Departure date & time
                </td>
                <td className="selected-impc">
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                    <Grid container justify="space-around">
                      <KeyboardDateTimePicker
                        disableToolbar
                        autoOk
                        variant="inline"
                        format="dd-MM-yyyy HH:mm"
                        ampm={false}
                        margin="normal"
                        id="date-picker-inline"
                        label="Departure date & time"
                        value={this.state.departureDateTime}
                        maxDate={this.state.plannedArrivalDateTime}
                        maxDateMessage="Departure date & time can not be after arrival date & time"
                        strictCompareDates
                        onChange={this.handleDepartureDate}
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Arrival date & time
                </td>
                <td className="selected-impc">
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                    <Grid container justify="space-around">
                      <KeyboardDateTimePicker
                        disableToolbar
                        autoOk
                        variant="inline"
                        format="dd-MM-yyyy HH:mm"
                        ampm={false}
                        margin="normal"
                        id="date-picker-inline"
                        label="Arrival date & time"
                        value={this.state.plannedArrivalDateTime}
                        onChange={this.handleArrivalDate}
                        minDate={this.state.departureDateTime}
                        minDateMessage="Departure date & time can not be after arrival date & time"
                        strictCompareDates
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Quantity
                </td>
                <td className="selected-impc">
                  <Input
                    id="quantity"
                    type="number"
                    value={this.state.quantity}
                    onChange={this.handleQuantity}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ step: 1 }}
                  />
                  <p style={{ color: 'red' }}>{this.state.errorQuantity}</p>
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Comment
                </td>
                <td className="selected-impc">
                  <Input
                    value={this.state.comments}
                    onChange={this.handleComments}
                    maxLength="40"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="after-box">
          <Button style={{ marginLeft: '25px', marginBottom: '10px' }} onClick={this.props.closeDialog}>Cancel</Button>
          <Button
            style={{ float: 'right', marginRight: '50px', marginBottom: '10px' }}
            onClick={this.confirmCreate}
            className={`primary-button-${!this.isFormValid()}`}
            disabled={!this.isFormValid()}
          >
            Confirm
          </Button>
        </div>
      </Dialog>
    );
  }
}

InternalRepatriationCreateFormDialog.propTypes = {
  row: PropTypes.objectOf(PropTypes.shape),
  appContext: PropTypes.objectOf(PropTypes.shape),
  postRepatriationsTransactionsCreateRequestActionCreator: PropTypes.func,
  openDialog: PropTypes.func.isRequired,
  closeDialog: PropTypes.func.isRequired,
  data: PropTypes.shape({
    inboundImpc: PropTypes.string,
    outboundImpc: PropTypes.string,
    inboundOperator: PropTypes.string,
    outboundOperator: PropTypes.string,
  }).isRequired,
  impcToList: PropTypes.arrayOf(PropTypes.string),
  impcFromList: PropTypes.arrayOf(PropTypes.string),
  operatorFromOptions: PropTypes.arrayOf(PropTypes.object),
  operatorToOptions: PropTypes.arrayOf(PropTypes.object),
  getImpcsOfSingleInboundOperatorRequestActionCreator: PropTypes.func,
  getImpcsOfSingleOutboundOperatorRequestActionCreator: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    appContext: getAssetType(state),
    impcToList: getInboundImpcsOfSingleOperator(state),
    impcFromList: getOutboundImpcsOfSingleOperator(state),
    operatorFromOptions: getLeftPostalOperatorsCodesOnly(state),
    operatorToOptions: getLeftPostalOperatorsCodesOnly(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  postRepatriationsTransactionsCreateRequestActionCreator,
  getImpcsOfSingleInboundOperatorRequestActionCreator,
  getImpcsOfSingleOutboundOperatorRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(InternalRepatriationCreateFormDialog);
